module.exports = __webpack_public_path__ + "img/EASG_Energiekongress_2027_mobile_3.65fba563.jpg";